import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { Link } from 'react-router'

import StateIcon from '../../shared/components/StateIcon'
import Icon from '../../shared/components/Icon'
import FileList from '../../shared/components/FileList'

export default class Pane extends Component {

  static propTypes = {
    data: PropTypes.object
  }

  getItemSpecForFieldGroup(name) {
    const { data } = this.props
    // eslint-disable-next-line no-nested-ternary
    return {
      isDirty: data.isFieldGroupDirty(name),
      isRejected: data.isFieldGroupDirty(name) && data.isRejected
    }
  }

  render() {
    const {
      data: {
        id,
        name,
        description,
        address,
        isDeactivated,
        email,
        website,
        phone,
        fax,
        openingHours,
        drivingInstructions,
        entryFeeAdults,
        entryFeePupils,
        entryFeeGroups,
        minGroupSize,
        equipments,
        qs,
        images,
        links
      }
    } = this.props

    const qsList = window.APP_CONFIG.list_qs
    const equipmentList = window.APP_CONFIG.list_equipment

    return (
      <div
        id="dashboard-pane-left"
        className="app-pane highlight pane column-md"
      >
        <div className="vertical museum-details">
          <h1 className="with-tools">
            Museum
            {' '}
            {isDeactivated ? <strong>[ deaktiviert ]</strong> : null}
          </h1>
          <div className="toolbar">
            <span className="tools">
              <a
                href={`${window.APP_CONFIG.API_HOST}/backend/museum/${id}/form`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Icon
                  className="tool-icon"
                  name="star-turquoise"
                />
                Bewertungszettel
              </a>
            </span>
            <span className="tools">
              <Link to={`/museum/${id}/edit`}>
                <Icon
                  className="tool-icon"
                  name="pencil-turquoise"
                />
                Bearbeiten
              </Link>
            </span>
          </div>
          <div className="vertical v-scrollable">
            <section className="vertical data-list">
              <div className="data-group">
                <h3>1. Anschrift</h3>
                <StateIcon
                  item={this.getItemSpecForFieldGroup('address')}
                />
                <strong>{name}</strong>
                <br />
                {address.street}
                {' '}
                {address.number}
                <br />
                {address.zip}
                {' '}
                {address.location}
                <br />
                {address.region
                  ? (window.APP_CONFIG.list_region
                    .find((region) => region.id * 1 === address.region * 1) || { title: '' }).title
                  : ''}
              </div>

              <div className="data-group">
                <h3>2. Informationen</h3>
                <StateIcon
                  item={this.getItemSpecForFieldGroup('contact')}
                />
                Telefon:
                {' '}
                {phone}
                <br />
                Fax:
                {' '}
                {fax}
                <br />
                <a href={`mailto:${email}`}>{email}</a>
                <br />
                <a href={website}>{website}</a>
                <br />
                <br />
                {description}
              </div>

              <div className="data-group">
                <h3>3. Besuch</h3>
                <StateIcon
                  item={this.getItemSpecForFieldGroup('openingHours')}
                />
                Öffnungszeiten:
                {' '}
                <br />
                {openingHours}
              </div>

              <div className="data-group">
                <StateIcon
                  item={this.getItemSpecForFieldGroup('drivingInstructions')}
                />
                Anfahrt:
                <br />
                {drivingInstructions}
              </div>

              <div className="data-group">
                <StateIcon
                  item={this.getItemSpecForFieldGroup('entryFees')}
                />
                Eintritt:
                {' '}
                <br />
                Erwachsene:
                {' '}
                <strong>{entryFeeAdults}</strong>
                {' '}
                €
                <br />
                Schüler:
                {' '}
                <strong>{entryFeePupils}</strong>
                {' '}
                €
                <br />
                Schulklassen:
                {' '}
                <strong>{entryFeeGroups}</strong>
                {' '}
                € (
                <strong>{minGroupSize}</strong>
                {' '}
                Begleitpersonen frei)
                <br />
              </div>

              <div className="data-group">
                <h3>4. Ausstattung</h3>
                <StateIcon
                  item={this.getItemSpecForFieldGroup('equipments')}
                />
                <ul>

                  {equipments.map((equipment) => (
                    <li key={equipment.value}>
                      {equipmentList.find((eq) => eq.id === equipment.value).title}
                      :
                      {equipment.attr}
                    </li>
                  ))}

                </ul>

                Qualitätssicherung:
                <br />
                <ul>

                  {qs.map((qsEntry) => (
                    <li key={qsEntry.value}>
                      {qsList.find((q) => q.id === qsEntry.value).title}
                    </li>
                  ))}

                </ul>

              </div>

              <div className="data-group">
                <h3>5. Medien</h3>
                <StateIcon
                  item={this.getItemSpecForFieldGroup('links')}
                />
                <FileList
                  list={links}
                  type="file"
                />
              </div>

              <div className="data-group">
                <StateIcon
                  item={this.getItemSpecForFieldGroup('images')}
                />
                <FileList
                  list={images}
                  type="image"
                />
              </div>
            </section>
          </div>
        </div>
      </div>
    )
  }

}



// WEBPACK FOOTER //
// ./src/museum/components/Pane.js